import { Action, createReducer, on } from '@ngrx/store';
import * as OrdersActions from '../actions/orders.actions';
import { Order, OrderDTO, OrdersFilters } from '../../commons/models/order';
import { AddressDTO } from '../../commons/models/address';
import { CustomerDTO } from '../../commons/models/customer';
import { ProductInOrderDTO } from '../../commons/models/product-in-order';
import { RiderDTO } from '../../commons/models/riders';
import { StatusDTO } from '../../commons/models/status';
import { Zones } from '../../commons/models/zone';
import { Product } from '../../commons/models/product';

export interface OrderState {
    orders: OrderDTO[],
    amount: number,
    delivery_date: string;
    delivery_time: string;
    notes?: string;
    address?: AddressDTO;
    address_id?: number;
    customer: CustomerDTO[];
    customer_id: number;
    discount?: number;
    delivery_man_id?: number;
    delivery_man?: RiderDTO;
    status_id?: number;
    status?: StatusDTO;
    products_in_order: ProductInOrderDTO[];
    eat_here?: boolean;
    deleted_at?: string;
    tenant_id?: number;
    selectedOrders: Order[],
    total: number;
    includes: string[];
    currentPage: number;
    perPage: number;
    order: string;
    direction: string;
    filters: OrdersFilters;
    dialogId: string;
    selectionDialogId: string;
    zones: Zones[];
    products: Product[];
}

const initialState: OrderState = {
    orders: [],
    amount: 0,
    delivery_date: '',
    delivery_time: '',
    customer: [],
    customer_id: 0,
    products_in_order: [],
    selectedOrders: [],
    total: 0,
    includes: [],
    currentPage: 1,
    perPage: 10,
    order: null,
    direction: null,
    filters: null,
    dialogId: null,
    selectionDialogId: null,
    zones: [],
    products: []
}

const ordersReducer = createReducer(
    initialState,
    on(OrdersActions.loadOrdersSuccess, (state, {orders}) => {
        console.log("Caricamento degli ordini dal reducer")
        return {...state, orders: orders}
    }),
    on(OrdersActions.loadOrdersCompleted, (state, {orders, currentPage, total, perPage, order, direction, filters, includes, zoneIds, statuses, date, customer_id, deliveryman_id, include_pick, include_delivery, with_sweets, include_archived, include }) => {
        console.log("Caricamento degli ordini dal reducer")
        return {...state, orders: orders, currentPage, total, perPage, order, direction, filters, includes, zoneIds, statuses, date, customer_id, deliveryman_id, include_pick, include_delivery, with_sweets, include_archived, include}
    })
);

export function reducer(state: OrderState | undefined, action: Action){
    return ordersReducer(state, action);
}